import { getSelectedCompanyId } from 'utils/company'
import { getLocaleId } from 'utils/getLocaleId'

interface IgetFilterVariablesProps {
  page: number
  perPage: number
  facetsInputs: any
  filterSearch: any
  query: any
  filterKey: string
}

export const getFilterVariables = ({
  page,
  perPage = 50,
  filterKey = '',
  facetsInputs = null,
  filterSearch = null,
  query = null,
}: IgetFilterVariablesProps) => {
  return {
    companyId: getSelectedCompanyId(),
    localeId: getLocaleId(),
    page,
    perPage,
    facetsInputs,
    ...(filterKey && { filterKey }),
    ...(filterSearch && { filterSearch }),
    ...(query && { query }),
    activeOfferStatusIds: [1],
  }
}
